<template>
  <div>
    <div class="titul gr-bg">
      <div class="titul-text">
        <h1>Библиотека в&nbsp;лицах</h1>
        <h5>Портретные очерки о&nbsp;сотрудниках Национальной&nbsp;библиотеки Удмуртской&nbsp;Республики</h5>
      </div>
    </div>

    <div class="fio">
      <div ref="fioRef" class="fio-back"
        :class="[first ? 'first' : '', third ? 'third' : '', fioAnimation ? 'fio-anim' : '']">
        <h1 class="family" :class="fioAnimation ? 'fio-anim' : ''">{{ family }}</h1>
        <h2 class="last-name" :class="fioAnimation ? 'fio-anim' : ''">{{ lastName }}</h2>
      </div>
    </div>

    <div class="container py-5 ">
      <div class="row ">
        <div class="col-lg-6 main-thre l-img mb-4 litivcenko">
          <router-link to="/drafters" class="plus-circle" :style="'--bgColor: #cec688bb;--bgColor2: #ca18d6bb;'">
            <img class="w-100" :style="'transform: scale(' + litovchenko + ');'" src="data/litovchenko/litovchenko.jpg"
              alt="">
          </router-link>
        </div>
        <div class="col-lg-6 about-text">
          <router-link class="empty-none" to="/drafters">
            <h2 class="from-the-compilers">От составителей</h2>
            <h5>Библиотека предоставляет массу возможностей для образования и&nbsp;интеллектуального развития,
              культурного
              досуга
              и&nbsp;релаксации в&nbsp;кругу друзей и&nbsp;близких по&nbsp;интересам. В&nbsp;библиотеку вы&nbsp;можете
              прийти, как и&nbsp;раньше, за&nbsp;книгой,
              но&nbsp;еще в&nbsp;ней можно интересно и&nbsp;разнообразно провести свое время. </h5>
            <h5>А библиотекарь сегодня&nbsp;— это профессионал своего дела, увлеченный не&nbsp;только чтением книг
              и&nbsp;организацией
              тишины в&nbsp;пространстве, но&nbsp;и&nbsp;способный внедрить на&nbsp;пользу дела цифровые технологии,
              организовать клуб для
              встреч со&nbsp;значимыми персонами региона, провести интеллектуальное <span
                class="lightening-pruning">мероприятие</span> </h5>
          </router-link>
        </div>
      </div>
    </div>

    <div v-for="(port, index1) in $store.getters.PORTRETS" :key="'fi' + index1">
      <div class="bg-all"
        :style="'background: linear-gradient(to top, ' + bg[index1][1] + ' 0%, ' + bg[index1][2] + ' 100%), url(' + bg[index1][0] + ') center no-repeat fixed;'">
        <h1 :style="'padding: ' + paddIng / 2 + 'px 0;'" v-html="$store.getters.PARTS[index1]" />
      </div>
      <div class="container">
        <div class="row">
          <div v-for="(portret, index) in port" :key="index" class="col-lg-4 ">

            <router-link :to="'/about/' + portret[0]" class="main-thre">
              <div class="plus-circle" ref="imgRef"
                :style="'--bgColor:' + portret[2] + ';--bgColor2:' + portret[3] + ';'"
                :class="(index + 1) === 3 || (index + 1) === 6 ? 'third-position' : (index + 1) === 2 || (index + 1) === 5 ? 'second-position' : 'first-position'"
                @mouseover="fioOn(portret[1])" @mouseleave="third = false; first = false; fioAnimation = false;"
                @touchstart="fioOn(portret[1])" @touchend="third = false; first = false; fioAnimation = false;">
                <img class="portret-grayscale" :src="'data/' + portret[0] + '/' + portret[0] + '_main.jpg'">
              </div>
            </router-link>

          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  metaInfo: {
    title: 'Библиотека в лицах',
    titleTemplate: '%s | Портретные очерки о сотрудниках Национальной библиотеки Удмуртской Республики',
  },
  data() {
    return {
      bg: [
        ['img/bg_2.jpg'],
        ['img/bg_3.jpg'],
        ['img/bg_4.jpg'],
        ['img/bg_5.jpg'],
        ['img/bg_6.jpg'],
        ['img/bg_7.jpg'],
        ['img/bg_8.jpg'],
        ['img/bg_9.jpg'],
        ['img/bg_10.jpg'],
        ['img/bg_11.jpg']
      ],
      first: false,
      third: false,
      mainCounter: -1,
      family: '',
      lastName: '',
      fioAnimation: false,
      timerId: null,
      isHover: false,
      paddIng: 400,
      scrolling: '0',
      screenHeight: document.documentElement.clientHeight,
      litovchenko: 1,
      fio: null,
      portrets: null
    }
  },
  updated() {
    this.colorsGenerator();
    // this.getJSON();
  },
  mounted() {
    window.scrollTo(0, 0);
    // document.title = 'Библиотека в лицах | Портретные очерки о сотрудниках Национальной библиотеки Удмуртской Республики';
    // this.colorsGenerator();
    // this.family = this.fio[0][0];
    // this.lastName = this.fio[0][1];
    window.addEventListener("scroll", this.onScroll, true)
    this.renderTrajectory();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll, true)
  },
  watch: {
    '$store.state.portrets': function () {
      this.family = this.$store.getters.FIO[0][0];
      this.lastName = this.$store.getters.FIO[0][1];
      this.colorsGenerator();
      // console.log("123");
      // Здесь ваша логика для отслеживания изменений переменной
    }
  },
  methods: {
    getJSON() {
      if (this.fio === null) {
        this.axios
          .get('data/main/fio.json')
          .then(response => (this.fio = response.data,
            // this.portrets = response.data.portrets,
            console.log(this.portrets),
            this.family = this.fio[0][0],
            this.lastName = this.fio[0][1]
            // this.colorsGenerator()
          ))
          // .catch(function (error) {
          //   console.log(error);
          // })
          ;
      }
    },
    colorRand() {
      // return '#' + (Math.floor(Math.random() * (6710886 - 2236962 + 1) + 2236962)).toString(16);
      return '#' + (Math.floor(Math.random() * (16777215 - 1048576 + 1) + 1048576)).toString(16);
    },
    colorsGenerator() {
      // for (let i = 0; i < this.portrets.length; i++)
      // {
      //   for (let j = 0; j < 2; j++ )
      //   {
      //     this.portrets[i][j].push(this.colorRand());
      //     this.portrets[i][j].push(this.colorRand());
      //   }
      // }
      if (this.bg[0][2] == undefined) {
        this.bg.forEach(element => {
          element[1] = this.colorRand() + '99';
          element[2] = this.colorRand() + '99';
        });

        this.$store.getters.PORTRETS.forEach(element => {
          element.forEach(el => {
            el[2] = this.colorRand();
            el[3] = this.colorRand();
          });
        });
      }
    },
    onScroll(e) {
      this.scrolling = Math.round(e.target.documentElement.scrollTop);
      // console.log(this.$refs.imgRef[0].parentElement.offsetTop);
      this.renderTrajectory();
      this.litovchenko = this.convertRange(this.inverse_exp(this.scrolling), 0.3, 1.4, 1, 1.4);
      // console.log(this.inverse_exp(this.scrolling)); 
    },
    renderTrajectory() {
      if (this.$refs.imgRef) {
        for (let i = 0; i < this.$refs.imgRef.length; i++) {
          // console.log(i 
          // + ' | ' + Math.round(e.target.documentElement.scrollTop)  
          // + ' | ' + this.$refs.imgRef[i].parentElement.offsetTop
          // + ' | ' + this.$refs.imgRef[i].parentElement.offsetHeight
          // + ' | ' + Math.round(e.target.documentElement.scrollTop) + this.screenHeight
          // );
          if (
            (this.scrolling <= this.$refs.imgRef[i].parentElement.offsetTop
              && this.scrolling + this.screenHeight > this.$refs.imgRef[i].parentElement.offsetTop)
            || (this.scrolling <= this.$refs.imgRef[i].parentElement.offsetTop + this.$refs.imgRef[i].parentElement.offsetHeight - this.paddIng
              && this.scrolling + this.screenHeight > this.$refs.imgRef[i].parentElement.offsetTop + this.$refs.imgRef[i].parentElement.offsetHeight - this.paddIng)
          ) {
            if (this.$refs.imgRef[i].classList.contains('first-position')) {
              this.$refs.imgRef[i].style.marginTop = 300 - ((this.scrolling + this.screenHeight - this.$refs.imgRef[i].parentElement.offsetTop - (this.$refs.imgRef[i].parentElement.offsetHeight / 4)) / 4) + 'px';
              // if (i == 3)
              //  console.log(i);
            }
            if (this.$refs.imgRef[i].classList.contains('third-position')) {
              this.$refs.imgRef[i].style.marginTop = ((this.scrolling + this.screenHeight - this.$refs.imgRef[i].parentElement.offsetTop - (this.$refs.imgRef[i].parentElement.offsetHeight / 4)) / 4) + 'px';
              // console.log(i);
            }
          }
        }
      }
    },
    fioOn(index) {
      // this.isHover = true;
      // if (this.timerId == null) {
      //   this.timerId = setTimeout(() => {
      // if (this.isHover && index >= 0) {
      if (this.$refs.imgRef[index] && this.$refs.imgRef[index].classList.contains('first-position')) {
        this.first = true;
      }
      // if (this.$refs.imgRef[index].classList.contains('second-position')) {
      //   this.$refs.fioRef.classList.add("second");
      // }
      if (this.$refs.imgRef[index] && this.$refs.imgRef[index].classList.contains('third-position')) {
        this.third = true;
      }
      this.family = this.$store.getters.FIO[index][0];
      this.lastName = this.$store.getters.FIO[index][1];
      this.fioAnimation = true;
    },
    inverse_exp(x) { // экспонента 0.1 - лямбда
      return 1.4 - Math.pow(Math.exp(1), -x * 0.001); // возведение в степень
    },
    convertRange(value, min, max, inMin, inMax) {
      return (value - min) / (max - min) * (inMax - inMin) + inMin;
    }


    //     }, 1500)
    //   }
    // }
  }
}
</script>
<style>
@font-face {
  font-family: 'Pattaya';
  src: url('~@/assets/fonts/Pattaya-Regular.woff2') format('woff2'),
    url('~@/assets/fonts/Pattaya-Regular.woff') format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

.about-text h5 {
  text-align: left;
  padding: 0 20px;
}

.titul {
  display: block;
  width: 100%;
  text-align: center;
}

.titul-text {
  /* display: inline-block; */
  width: 100%;
  color: aliceblue;
  padding: 200px 0;
}

h2 {
  font-family: 'Pattaya';
  font-weight: normal;
  font-style: normal;
  text-align: left;
  font-size: calc((100vw - 480px)/(1280 - 480) * (50 - 30) + 30px);
}

h2.from-the-compilers {
  padding: 0 20px;
  font-size: calc((100vw - 480px)/(1280 - 480) * (50 - 30) + 30px);
}

.lightening-pruning {
  background: linear-gradient(to right, black 0%, white 90%);
  background-clip: text;
  -webkit-text-fill-color: transparent;
  /* display: table; */
}

.titul-text h1 {
  font-family: 'Pattaya';
  font-weight: normal;
  font-style: normal;
  font-size: calc((100vw - 480px)/(1280 - 480) * (100 - 50) + 50px);
}

.bg-all h1 {
  font-family: 'Pattaya';
  font-weight: normal;
  font-style: normal;
  font-size: calc((100vw - 480px)/(1280 - 480) * (50 - 30) + 30px);
  color: aliceblue;
}

h1.family {
  font-size: calc((100vw - 480px)/(1280 - 480) * (40 - 30) + 30px);
}

h2.last-name {
  font-size: calc((100vw - 480px)/(1280 - 480) * (30 - 20) + 20px);
}

.titul-text h5 {
  font-weight: normal;
  font-style: italic;
  font-size: calc((100vw - 480px)/(1280 - 480) * (22 - 12) + 12px);
}

.fio {
  position: fixed;
  top: 70%;
  z-index: 2;
  width: 100%;
  pointer-events: none;
}

.fio-back {

  background-color: azure;
  width: 100%;
  text-align: center;
  margin: 0 auto;
  opacity: 0;
  padding: 10px 20px;
  transition: all .7s ease-out;

}

.fio-back.fio-anim {
  /* position: absolute; */
  opacity: 1;
  /* margin: 0; */
  width: max-content;
  box-shadow: 0px 10px teal;
}

.fio-back.fio-anim.first {
  position: absolute;
  left: 10%;
  margin: 0;
  opacity: 1;
  width: max-content;
  box-shadow: 10px 10px teal;
}

.fio-back.fio-anim.third {
  position: absolute;
  right: 10%;
  margin: 0;
  opacity: 1;
  width: max-content;
  box-shadow: -10px 10px teal;
}

.family {
  position: relative;
  text-align: center;
  left: -100vw;
  transition: all .5s ease-out;
}

.family,
.last-name {
  font-family: 'Pattaya';
  font-weight: normal;
  font-style: normal;
}

.last-name {
  position: relative;
  text-align: center;
  right: -100vw;
  transition: all .5s ease-out;
}

.last-name.fio-anim {
  right: 0%;
}

.family.fio-anim {
  left: 0%;
}

.empty-none {
  color: black;
  text-decoration: none;

}

.portret-grayscale {
  /* float: right; */
  /* display: inline-block; */
  width: 100%;
}



/* .plus-circle {
  /* display: inline-block;
  /* position: relative; */
/* line-height: 0; */
/* border-radius: 0;  */
/* } */
.l-img {
  height: min-content;
}

.plus-circle::after {
  content: '';
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: transparent;
  background-image: linear-gradient(to bottom right, var(--bgColor), var(--bgColor2));
  opacity: 0.3;
  transition: opacity .5s ease-out;
}

.plus-circle:hover::after {
  content: '';
  background: transparent;
  background-image: linear-gradient(to bottom right, var(--bgColor), var(--bgColor2));
  opacity: 0;
}

.first-position {
  position: relative;
  display: inline-block;
  /* margin-top: 170px; */
  vertical-align: top;

}

.second-position {
  position: relative;
  margin-top: 150px;

  display: inline-block;
  vertical-align: top;
}

.third-position {
  position: relative;
  display: inline-block;
  /* margin-top: 130px; */
  top: 0;
  vertical-align: top;
}

.main-thre {
  position: relative;
  /* width: 100%; */
  display: block;
}

.gr-bg {
  background: linear-gradient(to top right, #956ad2ec 0%, #f87d63ec 100%), url('~@/assets/bg_1.jpg') top center no-repeat fixed;
  background-size: cover;
  position: relative;
  display: block;
  width: 100%;
  margin: -74px 0 30px 0;
}

.bg-all {
  /* background: linear-gradient(to top, var(--bgColor3) 0%, var(--bgColor4) 100%), url('~@/assets/03.jpg') top center no-repeat fixed; */
  background-size: cover !important;
  position: relative;
  display: block;
  width: 100%;
  margin: 30px 0;
}

.row>* {
  padding-right: 0 !important;
  padding-left: 0 !important;
  margin-top: none;
}

.litivcenko {
  overflow: hidden;
}

/* .litivcenko img {
  transform: scale(1.2);
} */
</style>
